export default __webpack_public_path__ + "static/media/xlsx_thumbnail.c46c2cd7.png";